/* global FEATURES */
import { isObject } from 'lodash-es'
import FeatureApi from 'feature-toggle-api'
export const features = Object.freeze(FEATURES && isObject(FEATURES) ? FEATURES : {})
export const featureApi = new FeatureApi(features)
// eslint-disable-next-line spaced-comment
////////////////
////////////////////////////
/////////////
//////////////////////////
/////////////////////////////////////////////////////////////
////////////////
 
///////////////////////////////////////////
//////////////////
////////////////////////
///////////////////////////////////////////
//////////////////////////////////////////
//////////
